import $ from 'jquery';

export default function Permission(vm) {
    this.all = function(params) {
        var url = '/permission/list?' + $.param(params);

        return vm.get(url);
    };
}